import { useQuery } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import { GET_RECOMMENDATIONS_QUERY_KEY } from "./get-recommendations.static";
import type { UseGetRecommendationsOptions } from "./get-recommendations.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

export const useGetRecommendations = ({ config }: UseGetRecommendationsOptions) => {
  return useQuery({
    queryKey: [GET_RECOMMENDATIONS_QUERY_KEY],
    queryFn: () => {
      return vouchersDistributionsRepository.getRecommendations();
    },
    useErrorBoundary: false,
    ...config,
  });
};
